/**
 * LobbyOfTrustIssues.js
 *
 * Displays all players currently in the lobby.
 * Shows player avatar (pfp) and display name.
 */

import React from "react";
import Avatar from "../../../components/ui/Avatar";
import Button from "../../../components/ui/Button";

/**
 * Displays the Players in the lobby
 * @param {Object} user             -   user Information
 * @param {Object} room             -   For the name of the room
 * @param {Array} players           -   All the players
 * @param {Boolean} isAdmin         -   if the user is the admin
 * @param {Function} startTheGame   -   To start the game
 * @returns {JSX.Element}           -   List of players
 */
const LobbyOfTrustIssues = ({ user, room, players, isAdmin, startTheGame }) => {
    return (
        <div className="w-full min-h-screen px-4 py-6 mt-20">
            {/* Header */}
            <div className="w-full flex flex-col items-center mb-6">
                <h2 className="text-2xl font-semibold text-zinc-200 tracking-wide text-center">
                    {room?.id ? `Lobby — ${room.id}` : "Game Lobby"}
                </h2>
                <p className="text-zinc-500 text-sm mt-1">
                    {players?.length || 0} {players?.length === 1 ? "player" : "players"} joined
                </p>
            </div>

            {/* Player List */}
            <div className="w-full flex justify-center">
                <div className="flex flex-col gap-3 w-full max-w-md sm:max-w-lg">
                    {players && players.length > 0 ? (
                        players.map((player) => (
                            <div
                                key={player.id}
                                className="flex items-center gap-3 p-3 rounded-xl border border-zinc-200 hover:border-zinc-300 hover:bg-zinc-50 transition-all"
                            >
                                <Avatar src={player.pfp} alt={player.displayName} />
                                <div className="flex flex-col justify-center">
                                    <span className="text-base font-medium text-white truncate">
                                        {player.displayName}
                                        {user?.uid === player.id && (
                                            <span className="text-zinc-500 font-normal ml-1">(Me)</span>
                                        )}
                                    </span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-zinc-500 text-center py-6">
                            Waiting for players to join...
                        </p>
                    )}
                </div>
            </div>
            {isAdmin &&
                <div className="mt-10">
                    <Button variant="secondary" onClick={startTheGame}>
                        Start Game
                    </Button>
                </div>
            }
        </div>
    );
};

export default LobbyOfTrustIssues;